import { Controller } from "stimulus"

// Quick Reply Controller
// Handles clicking quick reply buttons in learning mode
// Populates the chat input with the selected option and submits the form
export default class extends Controller {
  static values = {
    threadId: String
  }

  select(event) {
    const message = event.currentTarget.dataset.quickReplyMessageValue
    if (!message) return

    // Find the chat form and input
    const form = document.getElementById('ai-chat-form')
    const input = document.getElementById('chatPromptField')

    if (!form || !input) {
      console.error('Quick reply: Could not find chat form or input')
      return
    }

    // Set the message in the input
    input.value = message

    // Hide the quick reply buttons immediately
    this.element.style.display = 'none'

    // Trigger input event to update any validation
    input.dispatchEvent(new Event('input', { bubbles: true }))
    input.dispatchEvent(new Event('change', { bubbles: true }))

    // Small delay to ensure form validation updates, then submit
    setTimeout(() => {
      // Use requestSubmit if available (fires submit event), otherwise use submit
      if (form.requestSubmit) {
        form.requestSubmit()
      } else {
        form.submit()
      }
    }, 50)
  }
}
